module.exports = __webpack_public_path__ + "img/ic_prev.6bc177fd.svg";